var map = {
	"./logo-adobe-ae.webp": 37416,
	"./logo-adobe-ai.webp": 19521,
	"./logo-adobe-ps.webp": 62153,
	"./logo-balsamiq-box.webp": 31295,
	"./logo-balsamiq.webp": 71285,
	"./logo-blender.webp": 3174,
	"./logo-canva.webp": 76564,
	"./logo-coreldraw.webp": 89085,
	"./logo-eraserio-box.webp": 62677,
	"./logo-excalidraw-box.webp": 46201,
	"./logo-excalidraw.webp": 30190,
	"./logo-figma-box.webp": 7333,
	"./logo-figma.webp": 30905,
	"./logo-invision.webp": 80590,
	"./logo-procreate.webp": 14463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71577;